import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './_service/user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {
    constructor(private user: UserService, private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.user.token) {
            if(route.url && route.url[0] && route.url[0].path) {
                let path = route.url[0].path;

                if(path == "kpi-data-entry" && !this.user.permissions.includes("kpi_data")) return false;
                if(path == "appointments" && !this.user.permissions.includes("appointments")) return false;
                if(path == "companies" && !this.user.permissions.includes("companies")) return false;
                if(path == "users" && !this.user.permissions.includes("passengers")) return false;
                if(path == "providers" && !this.user.permissions.includes("providers")) return false;
                if(path == "senior-centers" && !this.user.permissions.includes("senior_centers")) return false;
                if(path == "services" && !this.user.permissions.includes("services")) return false;
                if(path == "admin-users" && !this.user.permissions.includes("users")) return false;
                if(path == "administrative/audit-trail" && !this.user.permissions.includes("audit_trail")) return false;

                return true;
            }
            return true;
        }
        else {
            this.router.navigate(['/login'])
            return false;
        }
    }

}
